module.exports = __webpack_public_path__ + "img/shopping.3bdae505.png";